import { _PROJECT } from "services/api"
import LoginPage from "../views/Login/index";
import { LoadingMS } from "../views/Login/LoadingMS";
import ResetPasswordLogin from "../views/ResetPassword/ResetPassword";
import { IS_CRM } from "utils/variables";

export const authRoutes = [
  {
      path: "/login",
      name: !IS_CRM ? _PROJECT : "CRM",
      component: LoginPage,
      layout: "/auth",
    },
    {
      path: "/loading/:token",
      name: !IS_CRM ? "CRM_GLOBAL" : "CRM",
      component: LoadingMS,
      layout: "/auth",
    },
    {
      path: "/reset_contrasena_usuario",
      name: !IS_CRM ? _PROJECT : "CRM",
      component: ResetPasswordLogin,
      layout: "/auth",
    },
]